const templateMatserRouteList = {
  addOrEdit:"add-or-edit",
  observationTemplateMaster: "observation-template-master",
  PackageMaster: "package-master",
  PackageMasterOld: "package-master-old",
  pfshTemplateMaster: "pfsh-template-master",
  radiolodyTemplateMaster: "radiology-template-master",
  labTemplateMaster:"lab-template-master",
  managementMaster: "management-master",
  formMaster: "form-master",
};

export default templateMatserRouteList

